import "bootstrap/dist/js/bootstrap.bundle.js";
import { ApolloClient, HttpLink, InMemoryCache } from "@apollo/client";
import { ApolloProvider } from "@apollo/client/react";
import { createElement, StrictMode } from "react";
import * as ReactDOM from "react-dom/client";
import { I18nextProvider } from "react-i18next";
import CampsiteIndex from "../components/CampsiteIndex";
import i18n from "../services/i18n";
import "../services/maplibre-setup";

(function embed() {
  const rootElement = document.getElementById("lagerplatz_embed");
  if (!rootElement) return;

  const apiUrl = rootElement.dataset.apiUrl ?? "/graphql";
  const root = ReactDOM.createRoot(rootElement);
  const client = new ApolloClient({
    link: new HttpLink({ uri: apiUrl }),
    cache: new InMemoryCache({
      possibleTypes: {
        CampsiteTrait: ["CampsiteTraitBase", "CampsiteTraitDistance"],
      },
    }),
  });

  root.render(
    createElement(
      StrictMode,
      null,
      createElement(ApolloProvider, { client }, createElement(I18nextProvider, { i18n }, createElement(CampsiteIndex))),
    ),
  );
})();
